import { Action } from '@ngrx/store';

import { ScreenInformation } from './screeninformation.model';

export const ADD_STORE_INFORMATION = '[Chat] Add store information';


export class AddScreenInformation implements Action {
    readonly type = ADD_STORE_INFORMATION;

    constructor(public payload: ScreenInformation[] ) {}
}


export type StoreInformationActions =
| AddScreenInformation;
